import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import { LanguageMetadata } from "./types";
import { en } from "./locales/en";
import { bg } from "./locales/bg";

// Metadata for language switching UI
export const enMetadata: LanguageMetadata = {
  code: "en",
  name: "English",
};

export const bgMetadata: LanguageMetadata = {
  code: "bg",
  name: "Български",
};

export const languages: LanguageMetadata[] = [enMetadata, bgMetadata];

/** Resolve i18next language (e.g. `bg`, `en`, `en-US`) to a configured code. */
export function normalizeLanguageCode(lng: string): string {
  if (languages.some((l) => l.code === lng)) return lng;
  const byPrefix = languages.find((l) => lng.startsWith(`${l.code}-`));
  return byPrefix?.code ?? languages[0].code;
}

/** The other locale (for a two-language toggle). */
export function getAlternateLanguage(lng: string): LanguageMetadata {
  const current = normalizeLanguageCode(lng);
  return languages.find((l) => l.code !== current) ?? languages[1];
}

const savedLanguage = localStorage.getItem("lang") || bgMetadata.code;

// Initialize with BOTH languages preloaded for instant switching
i18n.use(initReactI18next).init({
  resources: {
    en: {
      translation: en.translation,
    },
    bg: {
      translation: bg.translation,
    },
  },
  lng: savedLanguage,
  fallbackLng: bgMetadata.code,
  interpolation: {
    escapeValue: false,
  },
  debug: false,
  react: {
    useSuspense: false, // Disable suspense for instant rendering
  },
});

// Save language changes to localStorage
i18n.on("languageChanged", (lng) => {
  localStorage.setItem("lang", lng);
});

export default i18n;
